import TSearchbar from './t-searchbar';

export default TSearchbar;